import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  role?: any;
  type?: string;
  idTipo?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  role: any;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

const MENUITEMS: Menu[] = [
  {
    state: 'inicio', name: 'HOME', type: 'link', icon: 'home', role: ['super', 'admin']
  },
  {
    state: 'admin', name: 'ADMIN', type: 'sub', icon: 'settings', role: ['super', 'admin'],

    children: [
      {state: 'proveedores',    name: 'PROVIDERS',  role: ['super', 'admin']},
      {state: 'usuarios',       name: 'USERS',      role: ['super']},
      {state: 'empresas',       name: 'COMPANIES',  role: ['super']},
      {state: 'sucursales',     name: 'OFFICES',    role: ['super']},
      // {state: 'departamentos', name: 'DEPARTAMENTS', role: ['super']},
      {state: 'workflows',      name: 'WORKFLOWS',  role: ['super']},
      {state: 'general',        name: 'GENERAL',    role: ['super', 'admin']},
      {state: 'centro-costos',  name: 'ADMINCC',    role: ['super', 'admin']},
      {state: 'orden-interno',  name: 'ADMINOI',    role: ['super', 'admin']},
    ]
  },
  /*{
    state: 'recepciones',
    name: 'RECEPTIONS',
    type: 'sub',
    icon: 'assignment',
    role: ['all'],
    children: [
      {state: 'facturas', name: 'RECEPTIONINVOICES'},
    ]
  },*/
  {
    state: 'ordenes-cerradas', name: 'ORDERSCLOSE', type: 'sub', icon: 'done_all', role: ['all'],

      children: [
        {state: 'lista',    name: 'LISTCLOSEORDERS'},
        {state: 'buscar',   name: 'SEARCHORDERSCLOSE'},
        {state: 'aprobar',  name: 'APPROVESERVICESORDERS'}
    ]
  },
  {
    state: 'ordenes-abiertas', name: 'ORDERSOPEN', type: 'sub', icon: 'description', role: ['all'],

      children: [
        {state: 'lista',  name: 'LISTOPENORDERS'},
        {state: 'buscar', name: 'SEARCHORDERSOPEN'},
    ]
  },
  {
    state: 'sistema',
    name: 'SYSTEM',
    type: 'link',
    icon: 'settings_brightness',
    role: ['all']
  },

  {
    state: 'aprobar-ordenes',
    name: 'APPROVEORDERS',
    type: 'sub',
    icon: 'done_all',
    role: ['all'],
    children: [
      {state: 'aprobar-cerradas', name: 'APPROVECLOSEORDERS', idTipo : "1"},
      {state: 'aprobar-abiertas', name: 'APPROVEOPENORDERS',  idTipo : "2"}
    ]
  },

  /*{
    state: 'system',
    name: 'SYSTEM',
    type: 'sub',
    icon: 'playlist_add',
    role: ['all'],
    *badge: [
      {type: 'blue-grey', value: '4'
      }
    ],*
    children: [
      {state: 'ordenes', name: 'ORDERSPURCHASE'},
      {state: 'proveedores', name: 'PROVIDERS'},
    ]
  },*/
  {
    state: 'reportes',
    name: 'REPORTS',
    type: 'sub',
    icon: 'trending_up',
    role: ['all'],
    children: [
      {state: 'conciliacion', name: 'CONCILIACION'},
      {state: 'facturas', name: 'INVOICES'},
      {state: 'ordenes', name: 'ORDERSPURCHASE'}

    ]
  },
  {
    state: 'consignacion',
    name: 'CONSIGNMENT',
    type: 'sub',
    icon: 'receipt',
    role: ['all'],
    children: [
      {state: 'carga', name: 'UPLOADCONSIGNMENT'},
      {state: 'reporte', name: 'LISTCONSIGNMENT'},

    ]
  },
  {
    state: 'servicios',
    name: 'SERVICES',
    type: 'sub',
    icon: 'work',
    role: ['all'],
    children: [
      {state: 'lista', name: 'LISTSERVICES'},
      {state: 'buscar', name: 'CHARGESERVICES'},
      {state: 'retenciones', name: 'MANAGERETENTIONS'},
      {state: 'aprobar', name: 'APPROVESERVICES'}
    ]
  },
  {
    state: 'aprobar-servicios',
    name: 'SERVICESAPPROVE',
    type: 'link',
    icon: 'check_circle_outline',
    role: ['all']
  },
  {
    state: 'facturas-pagos',
    name: 'INVOICEPAYMENTS',
    type: 'link',
    icon: 'payment',
    role: ['all']
  },
  {
    state: 'pagos-manuales',
    name: 'MANUALPAYMENTS',
    type: 'sub',
    icon: 'attach_money',
    role: ['all'],
    children: [
      {state: 'buscar', name: 'SEARCHPAYMENTMANUAL'},
      {state: 'Listado', name: 'LISTMANUALPAYMENT'}
    ]
    // badge: [{type: 'blue-grey', value: '1'}]
  },
  {
    state: 'notas-credito',
    name: 'CREDITNOTES',
    type: 'sub',
    icon: 'speaker_notes_off',
    role: ['all'],
    children: [
      { state: 'Listado', name: 'LISTNOTES' },
      { state: 'Buscar',  name: 'SEARCHNOTES' }
    ]
    // badge: [{type: 'blue-grey', value: '1'}]
  },
  {
    state: 'complementos-pagos', name: 'COMPLEMENTPAYMENTS',
    type: 'sub',
    icon: 'playlist_add',
    role: ['all'],
    children: [
      {state: 'carga', name: 'CHARGECOMPLEMENTS'},
      {state: 'historial', name: 'HISTORYCOMPLEMENTS'},
      {state: 'pagos', name: 'PAYMENTPENDINGCOMPLEMENTS'},
      {state: 'cargaMasiva', name: 'BULKLOAD'}
    ]
  },

  {
    state: 'ayuda',
    name: 'HELP',
    type: 'sub',
    icon: 'help',
    role: ['all'],
    children: [
      {state: 'faqs', name: 'FAQS'},
      {state: 'manual', name: 'MANUALUSER'},
    ]
  },

  {
    state: 'contact',
    name: 'CONTACT',
    type: 'link',
    icon: 'contact_mail',
    role: ['all']
  },

  {
    state: 'comunicados',
    name: 'NOTICE',
    type: 'link',
    icon: 'description',
    role: ['all']
  }
];
// facturas y pagos, pagos manuales, complemento de pago,
@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }

  add(menu: Menu) {
    MENUITEMS.push( menu);
  }
}
